import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-update-season',
    templateUrl: './update-season.component.html',
    styleUrls: ['./update-season.component.css'],
    standalone: false
})
export class UpdateSeasonComponent {

  constructor(
  public saveSeasonDetailsDialog: MatDialogRef<UpdateSeasonComponent>,
) {
}

  cancel(): void {
    this.saveSeasonDetailsDialog.close({"option": "cancel"});
  }

  save(): void {
    this.saveSeasonDetailsDialog.close({"option": "save"});
  }
}
